import axios from 'axios';
import {
  BulkJobAction,
  ListBulkJobsResponse,
  ProjectReportBulkJob,
  TriggerBulkActionResponse,
} from 'organisms/CloudOpsReportAdmin/bulk/types';

const getBaseUrl = () => process.env.REACT_APP_USER_SERVICE || '';

export const bulkApi = {
  async trigger(
    action: BulkJobAction,
    reportIds: number[]
  ): Promise<TriggerBulkActionResponse> {
    const { data } = await axios.post<TriggerBulkActionResponse>(
      `${getBaseUrl()}/project/reports/bulk-action`,
      { action, report_ids: reportIds }
    );
    return data;
  },

  async getJob(id: number): Promise<ProjectReportBulkJob> {
    const { data } = await axios.get<ProjectReportBulkJob>(
      `${getBaseUrl()}/project/reports/bulk-jobs/${id}`
    );
    return data;
  },

  async listJobs(page = 1, limit = 20): Promise<ListBulkJobsResponse> {
    const { data } = await axios.get<ListBulkJobsResponse>(
      `${getBaseUrl()}/project/reports/bulk-jobs`,
      { params: { page, limit } }
    );
    return data;
  },
};
